var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "collapse storefinderAccordion__panel storefinderAccordion__panel--visible",
      class: { "storefinderAccordion__panel--open": _vm.showContent },
    },
    [
      _c(
        "div",
        { staticClass: "storefinderAccordion__panel__inner" },
        [
          _c(
            "header",
            {
              staticClass: "storefinderAccordion__panelHeader interactive",
              on: { click: _vm.toggle },
            },
            [
              _c("IconArrow", { staticClass: "storefinderAccordion__arrow" }),
              _vm._v(" "),
              _vm._t("title"),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "transition",
            {
              attrs: { name: "storefinder-collapse" },
              on: {
                enter: _vm.enter,
                "after-enter": _vm.afterEnter,
                leave: _vm.leave,
              },
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showContent,
                      expression: "showContent",
                    },
                  ],
                  class: {
                    "item-content": true,
                    "content--open": _vm.showContent,
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "content-container" },
                    [_vm._t("default")],
                    2
                  ),
                ]
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }